<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;
	const book_url = "https://www.ihg.com/holidayinnresorts/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99502222&icdv=99502222&qSlH=DPSBB&qRms=1&qAdlt=1&qChld=0&qCiD=03&qCiMy=02025&qCoD=04&qCoMy=02025&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=HI&qDest=Jl%20Pratama,%20No%2086,%20Tanjung%20Benoa,%20Bali,%20ID&srb_u=1&qChAge=&qRmFltr=";

	let partner = data?.partner;
	let room = data?.room;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);

	});
</script>

<svelte:head>
	<title>Rooms - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="http://50.6.171.246:5000/rooms">
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src="/img/bg-header-room.webp"
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Rooms & Suites</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 rooms-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">{$_('room_title_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica">
					{$_('room_desc_1')}
				</p>
			</div>
		</div>
		<div class="row g-0 align-items-center">
			{#each room as room, index}
				{#if index % 2 === 0}
					<div class="col-md-12 row g-0 py-md-5 py-3">
						<div class="col-md-9 col-11 fs-5 main-color ff-lola-mr text-uppercase mb-md-4 mb-3">
							<div class="swiper slider-img-room position-relative">
								<div class="swiper-wrapper">
									{#each room.featured_images as img}
										<div class="swiper-slide">
											<div class="ratio ratio-21x9 rounded-end-4">
												<img src={img.path} class="w-100 h-100 object-fit-cover rounded-end-4" />
											</div>
										</div>
									{/each}
								</div>

								<div
									class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-end z-3 p-md-4 p-3"
								>
									<div class="d-flex">
										<span class="btn-prev d-flex align-items-center justify-content-center me-2"
											><i class="ph-light ph-caret-left"></i></span
										>
										<span class="btn-next d-flex align-items-center justify-content-center"
											><i class="ph-light ph-caret-right"></i></span
										>
									</div>
								</div>

								<div
									class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-md-center justify-content-start z-2 p-md-4 p-3 text-white"
								>
									<div class="swiper-pagination pagination-slider-img-room"></div>
								</div>
							</div>
						</div>
						<div class="col-md-8 col-10 offset-1 offset-md-1">
							<p class="mb-3 main-color display-5 ff-lola-bir lh-2">{room.name}</p>
							<p class="line mb-md-4 mb-3"></p>
							<p class="ff-helvetica">{room.excerpt}</p>
							<p class="ff-helvetica mb-1">
								<i class="ph-fill ph-ruler me-2"></i>{room.feature.size}
							</p>
							<p class="ff-helvetica mb-1">
								<i class="ph-fill ph-bed me-2"></i>{room.feature.bed}
							</p>
							<p class="ff-helvetica mb-4">
								<i class="ph-fill ph-binoculars me-2"></i>{room.feature.view}
							</p>
							<p class="ff-lola-mr">
								<a data-sveltekit-reload href="/{lang}/rooms/{room.slug}" class="btn main-btn-outline px-4 py-2 me-2 d-none d-md-inline-block"
									>{$_('btn_view_details')}</a
								>
								<a
									role="button"
									data-bs-toggle="modal"
									data-bs-target="#modal-{room.slug}"
									class="btn main-btn-outline px-4 py-2 me-2 d-inline-block d-md-none"
									>{$_('btn_view_details')}</a
								>
								<a data-sveltekit-reload href="{book_url}" target="_blank" class="btn main-btn px-4 py-2">{$_('btn_book')}</a>
							</p>
						</div>
					</div>
				{:else}
					<div class="col-md-12 row g-0 py-md-5 py-3 right-content-rooms">
						<div
							class="col-md-9 col-11 offset-1 offset-md-3 fs-5 main-color ff-lola-mr text-uppercase mb-md-4 mb-3"
						>
							<div class="swiper slider-img-room position-relative">
								<div class="swiper-wrapper">
									{#each room.featured_images as img}
										<div class="swiper-slide">
											<div class="ratio ratio-21x9 rounded-start-4">
												<img src={img.path} class="w-100 h-100 object-fit-cover rounded-start-4" />
											</div>
										</div>
									{/each}
								</div>

								<div
									class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-start z-3 p-md-4 p-3"
								>
									<div class="d-flex">
										<span class="btn-prev d-flex align-items-center justify-content-center me-2"
											><i class="ph-light ph-caret-left"></i></span
										>
										<span class="btn-next d-flex align-items-center justify-content-center"
											><i class="ph-light ph-caret-right"></i></span
										>
									</div>
								</div>

								<div
									class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-md-center justify-content-end z-2 p-md-4 p-3 text-white"
								>
									<div class="swiper-pagination pagination-slider-img-room"></div>
								</div>
							</div>
						</div>
						<div class="col-md-8 col-10 offset-1 offset-md-3">
							<p class="mb-3 main-color display-5 ff-lola-bir lh-2">{room.name}</p>
							<p class="line mb-md-4 mb-3"></p>
							<p class="ff-helvetica">{room.excerpt}</p>
							<p class="ff-helvetica mb-1">
								<i class="ph-fill ph-ruler me-2"></i>{room.feature.size}
							</p>
							<p class="ff-helvetica mb-1">
								<i class="ph-fill ph-bed me-2"></i>{room.feature.bed}
							</p>
							<p class="ff-helvetica mb-4">
								<i class="ph-fill ph-binoculars me-2"></i>{room.feature.view}
							</p>
							<p class="ff-lola-mr">
								<a data-sveltekit-reload href="/{lang}/rooms/{room.slug}" class="btn main-btn-outline px-4 py-2 me-2 d-none d-md-inline-block"
									>{$_('btn_view_details')}</a
								>
								<a
									role="button"
									data-bs-toggle="modal"
									data-bs-target="#modal-{room.slug}"
									class="btn main-btn-outline px-4 py-2 me-2 d-inline-block d-md-none"
									>{$_('btn_view_details')}</a
								>
								<a data-sveltekit-reload href="{book_url}" target="_blank" class="btn main-btn px-4 py-2">{$_('btn_book')}</a>
							</p>
						</div>
					</div>
				{/if}

				<div
					class="modal fade"
					id="modal-{room.slug}"
					tabindex="-1"
					aria-labelledby="exampleModalLabel"
					aria-hidden="true"
				>
					<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
						<div class="modal-content">
							<div class="modal-header">
								<p class="modal-title fs-5 ff-lola-mr">{$_('room_detail')}</p>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
								></button>
							</div>
							<div class="modal-body">
								<div class="swiper slider-img-room position-relative">
									<div class="swiper-wrapper">
										{#each room.featured_images as img}
											<div class="swiper-slide">
												<div class="ratio ratio-1x1 rounded-4">
													<img src={img.path} class="w-100 h-100 object-fit-cover rounded-4" />
												</div>
											</div>
										{/each}
									</div>

									<div
										class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-start z-3 p-md-4 p-3"
									>
										<div class="d-flex">
											<span class="btn-prev d-flex align-items-center justify-content-center me-2"
												><i class="ph-light ph-caret-left"></i></span
											>
											<span class="btn-next d-flex align-items-center justify-content-center"
												><i class="ph-light ph-caret-right"></i></span
											>
										</div>
									</div>

									<div
										class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-md-center justify-content-end z-2 p-md-4 p-3 text-white"
									>
										<div class="swiper-pagination pagination-slider-img-room"></div>
									</div>
								</div>

								<div class="row g-0 mt-3">
									<div class="col-12 mb-2">
										<p class="mb-3 main-color fs-3 ff-lola-bir">{room.name}</p>
										<p class="">
											<span class="badge secondary-badge fw-light ff-helvetica me-1 mb-2 px-4 py-2"
												><i class="ri-instance-fill"></i> {room.feature.size}</span
											>
											<span class="badge secondary-badge fw-light ff-helvetica me-1 mb-2 px-4 py-2"
												><i class="ri-group-fill"></i> {room.feature.occupancy}</span
											>
											<span class="badge secondary-badge fw-light ff-helvetica me-1 mb-2 px-4 py-2"
												><i class="ri-hotel-bed-fill"></i> {room.feature.bed}</span
											>
										</p>
									</div>
									<div class="col-12">
										<p class="mb-0 main-color fs-5 ff-lola-mr">{$_('room_facilities')}</p>
										<ul class="ps-2 list-room-facilities" style="columns:2; list-style: none;">
											{#each room.facilities as facility}
												<li class="pe-2">
													<span class="me-1 icon">{@html facility.icon}</span><span class="facility"
														>{facility.name}</span
													>
												</li>
											{/each}
										</ul>
									</div>
								</div>
							</div>
							<div class="modal-footer">
								<a data-sveltekit-reload href="{book_url}" target="_blank" class="btn main-btn w-100 py-2">{$_('btn_book')}</a>
							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>

	<div class="container rooms-amenities pb-md-5 pb-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-md-4 mb-3 main-color display-5 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">
					{$_('room_title_2')}
				</p>
			</div>
			<div class="col-md-10 row g-0 justify-content-center additional-amenities">
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-beer-bottle fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_2')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-mouse fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_4')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-film-script fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_5')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-siren fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_6')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-coffee fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_7')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-vault fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_8')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-md-3 p-2 pb-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-desk fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_aa_10')} </span>
				</div>
			</div>
		</div>
	</div>

	<div class="container rooms-amenities-2 pb-md-5 pb-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-md-4 mb-3 main-color display-5 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">
					{$_('room_title_3')}
				</p>
			</div>
			<div class="col-md-10 row g-0 justify-content-center justify-content-md-start">
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_gf_1')} </span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1">
						{$_('room_gf_2')}
					</span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_gf_3')} </span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1">
						{$_('room_gf_4')}
					</span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_gf_5')} </span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_gf_6')} </span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1">
						{$_('room_gf_7')}
					</span>
				</div>
				<div class="col-md-4 col-10 d-flex align-items-center p-md-3 p-2 pb-3">
					<i class="ph-fill ph-check-circle fs-4 me-2 main-color"></i>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_gf_8')} </span>
				</div>
			</div>
		</div>
	</div>

	<div class="container rooms-amenities-3 pb-md-5 pb-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-md-4 mb-3 main-color display-5 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">
					{$_('room_title_4')}
				</p>
			</div>
			<div class="col-md-10 row g-0 justify-content-center">
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-lightning fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_ar_1')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-baby fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_ar_2')} </span>
				</div>
			</div>
			<div class="col-md-10 row g-0 justify-content-center">
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-coat-hanger fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_ar_3')} </span>
				</div>
				<div class="col-md-4 col-11 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-bed fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('room_ar_4')} </span>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer award={award}/>

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #757fbd;
		width: 25%;
	}
	.slider-img-room .nav-slider-img-room .btn-prev,
	.slider-img-room .nav-slider-img-room .btn-next {
		width: 50px;
		height: 50px;
		border-radius: 10px;
		border: 2px solid white;
		color: white;
		font-size: 26px;
		cursor: pointer;
		transition: 0.3s all;
	}
	.slider-img-room .nav-slider-img-room .btn-prev:hover,
	.slider-img-room .nav-slider-img-room .btn-next:hover {
		background-color: rgba(255, 255, 255, 0.3);
		transition: 0.3s all;
	}
	.pagination-slider-img-room {
		bottom: unset !important;
		top: unset !important;
		left: unset !important;
		width: unset !important;
		font-size: 26px !important;
	}
	.rooms-welcome .right-content-rooms {
		position: relative;
	}
	.rooms-welcome .right-content-rooms:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 20%;
		height: 65%;
		background-color: #757fbd;
	}
	.rooms-amenities .icon {
		background-color: #e6e9f8;
		color: #757fbd;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.rooms-amenities-3 .icon {
		background-color: #e6e9f8;
		color: #757fbd;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	@media (max-width: 600px) {
		.rooms-welcome .right-content-rooms:before {
			content: unset;
		}
		.rooms-welcome .slider-img-room .ratio-21x9 {
			aspect-ratio: 9/7 !important;
		}
		/* .additional-amenities span{
			font-size: 16px!important;
		} */
	}
</style>
